/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Button } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import pdfImage from '../../../assets/pdf.png';
import { RoleIds } from '../../../models';

import {
    AfricanDocument,
    ExoticDocument,
    NAmericanDocument,
    FurPriceDocument,
    ExoticSaltedDocument,
    NAmericanSaltedDocument,
} from '../../../assets/pdfs';

const data = [ExoticDocument, NAmericanDocument];

const dataFur = [FurPriceDocument];

const dataSalted = [ExoticSaltedDocument, NAmericanSaltedDocument, AfricanDocument];
const pricesText = `The prices are available for professional taxidermists only. To get access to them login to your Taxidermy STARS account or call our office at 1-866-TAN-FURS.`;

function Prices({ showFrozenAndSaltedPrices }) {
    let rowCounter = 0;
    return (
        <>
            <h1 className="double">Price Lists</h1>
            <div className="pdf-form-container">
                <h2>Taxidermy STARS Pricing</h2>
                {showFrozenAndSaltedPrices &&
                    data.map(e => (
                        <div key={(rowCounter += 1)}>
                            <hr />
                            <div className="pdf-form">
                                <a href={e.file} rel="noopener noreferrer" target="_blank">
                                    <img src={pdfImage} alt="pdf-icon" />
                                </a>

                                <div className="pdf-form-text">
                                    <span className="pdf-title">{e.name}</span>
                                    <span className="pdf-size">{e.size}MB</span>
                                </div>

                                <Button type="secondary" href={e.file} target="_blank">
                                    Download
                                </Button>
                            </div>
                        </div>
                    ))}
                {!showFrozenAndSaltedPrices && <p>{pricesText}</p>}
                <hr />
            </div>
            <div className="pdf-form-container">
                <h2>Intact Fur Dressing</h2>

                {dataFur.map(e => (
                    <div key={(rowCounter += 1)}>
                        <hr />
                        <div className="pdf-form">
                            <a href={e.file} rel="noopener noreferrer" target="_blank">
                                <img src={pdfImage} alt="pdf-icon" />
                            </a>

                            <div className="pdf-form-text">
                                <span className="pdf-title">{e.name}</span>
                                <span className="pdf-size">{e.size}MB</span>
                            </div>

                            <Button type="secondary" href={e.file} target="_blank">
                                Download
                            </Button>
                        </div>
                    </div>
                ))}

                <hr />
                <div style={{ marginTop: '77px' }}>
                    <h2>Salted Taxidermy Tanning</h2>
                    {dataSalted.map(e => (
                        <div key={(rowCounter += 1)}>
                            <hr />
                            <div className="pdf-form">
                                <a href={e.file} rel="noopener noreferrer" target="_blank">
                                    <img src={pdfImage} alt="pdf-icon" />
                                </a>

                                <div className="pdf-form-text">
                                    <span className="pdf-title">{e.name}</span>
                                    <span className="pdf-size">{e.size}MB</span>
                                </div>

                                <Button type="secondary" href={e.file} target="_blank">
                                    Download
                                </Button>
                            </div>
                        </div>
                    ))}
                    <hr />
                </div>
            </div>
        </>
    );
}

Prices.propTypes = {
    showFrozenAndSaltedPrices: PropTypes.bool,
};

Prices.defaultProps = {
    showFrozenAndSaltedPrices: false,
};

const mapStateToProps = ({
    authentication: {
        user: { roleId },
        loggedIn,
    },
}) => {
    const isProClient = roleId === RoleIds.PROCLIENT;
    return {
        isProClient,
        showFrozenAndSaltedPrices: loggedIn && isProClient,
    };
};

export default connect(mapStateToProps)(Prices);
